<template>
  <main>
    <a-spin :spinning="loading">
      <notification-bar
        :message="notification.message"
        :on-close="onNotificationClose"
        :show="notification.show"
        :type="notification.type"
      />
      <header class="top-bar">
        <flex-grid align-items="center" width="100%">
          <flex-grid-item>
            <router-link
              v-if="!isSearchingDomain"
              class="workflows"
              :to="{
                name: 'workflow-list',
                params: { clusterName: $route.params.clusterName },
              }"
            >
              <span class="main-title">Athena</span>
            </router-link>
          </flex-grid-item>

          <flex-grid-item v-if="$route.params.workflowId">
            <span>{{ $route.params.workflowId }}</span>
          </flex-grid-item>

          <flex-grid-item v-if="$route.params.taskList">
            <span>{{ $route.params.taskList }}</span>
          </flex-grid-item>
          <flex-grid-item class="auth-conatiner">
            <a-dropdown
              v-if="userName && $route.name !== 'login'"
              :trigger="['click']"
            >
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                {{ userName }} <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item key="0">
                  <a @click="logOut()">{{ $t("dj-登出") }}</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
            <a-dropdown
              v-if="tenantName && $route.name === 'workflow-list' && isIsV"
              :trigger="['click']"
              overlay-class-name="tenants-dropdown"
            >
              <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
                {{ tenantName }} <a-icon type="down" />
              </a>
              <a-menu slot="overlay" v-model="selectedKeys">
                <a-menu-item
                  v-for="tenant in tenantList"
                  :key="tenant.id"
                  :class="{ isSelected: tenant.id === tenantId }"
                >
                  <a @click="changeTenant(tenant)">{{ tenant.name }}</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </flex-grid-item>
        </flex-grid>
      </header>
      <cross-region>
        <domain>
          <router-view
            :date-format="settings.dateFormat"
            :time-format="settings.timeFormat"
            :timezone="settings.timezone"
            :workflow-history-event-highlight-list="
              settings.workflowHistoryEventHighlightList
            "
            :workflow-history-event-highlight-list-enabled="
              settings.workflowHistoryEventHighlightListEnabled
            "
            @onWorkflowHistoryEventParamToggle="
              onWorkflowHistoryEventParamToggle
            "
            @onNotification="onNotification"
          ></router-view>
        </domain>
      </cross-region>
      <modals-container />
      <v-dialog />
      <news-modal :news-items="newsItems" @before-close="onNewsDismiss" />
    </a-spin>
  </main>
</template>
/* eslint-disable func-names */
<script>
import { mapGetters } from "vuex";
import { CrossRegion, Domain } from "@/containers";
import {
  DATE_FORMAT_MMM_D_YYYY,
  DATE_FORMAT_OPTIONS,
  ENVIRONMENT_LIST,
  LOCAL_STORAGE_NEWS_LAST_VIEWED_AT,
  LOCAL_STORAGE_SETTINGS,
  NOTIFICATION_TIMEOUT,
  NOTIFICATION_TYPE_SUCCESS,
  TIME_FORMAT_12,
  TIME_FORMAT_OPTIONS,
  TIMEZONE_LOCAL,
  TIMEZONE_OPTIONS,
} from "@/constants";
import {
  getEnvironment,
  getEnvironmentList,
  parseStringToBoolean,
  workflowHistoryEventHighlightListAddOrUpdate,
} from "@/helpers";
import api from "@/api";
import i18n from "@/assets/i18n/translate-message";
import envServiceAPI from "@/api/modules/envAPI";
import {
  FlexGrid,
  FlexGridItem,
  NewsModal,
  NotificationBar,
} from "./components";
import logo from "./assets/logo.svg";

export default {
  components: {
    "cross-region": CrossRegion,
    domain: Domain,
    "flex-grid": FlexGrid,
    "flex-grid-item": FlexGridItem,
    "news-modal": NewsModal,
    "notification-bar": NotificationBar,
  },
  data() {
    const { origin } = window.location;
    const environmentList = ENVIRONMENT_LIST;

    return {
      selectedKeys: [],
      loading: false,
      environment: {
        list: getEnvironmentList({
          environmentList,
          origin,
        }),
        value: getEnvironment({
          environmentList,
          origin,
        }),
      },
      isSearchingDomain: false,
      newsLastUpdated: localStorage.getItem(LOCAL_STORAGE_NEWS_LAST_VIEWED_AT),
      newsItems: [],
      logo,
      notification: {
        message: "",
        show: false,
        type: "",
        timeout: undefined,
      },
      settings: {
        dateFormat:
          localStorage.getItem(LOCAL_STORAGE_SETTINGS.dateFormat) ||
          DATE_FORMAT_MMM_D_YYYY,
        dateFormatOptions: DATE_FORMAT_OPTIONS,
        timeFormat:
          localStorage.getItem(LOCAL_STORAGE_SETTINGS.timeFormat) ||
          TIME_FORMAT_12,
        timeFormatOptions: TIME_FORMAT_OPTIONS,
        timezone:
          localStorage.getItem(LOCAL_STORAGE_SETTINGS.timezone) ||
          TIMEZONE_LOCAL,
        timezoneOptions: TIMEZONE_OPTIONS,
        workflowHistoryEventHighlightList:
          JSON.parse(
            localStorage.getItem(
              LOCAL_STORAGE_SETTINGS.workflowHistoryEventHighlightList
            )
          ) || [],
        workflowHistoryEventHighlightListEnabled: parseStringToBoolean(
          localStorage.getItem(
            LOCAL_STORAGE_SETTINGS.workflowHistoryEventHighlightListEnabled
          ),
          true
        ),
      },
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    "notification.show": function (value) {
      clearTimeout(this.notification.timeout);

      if (value) {
        this.notification.timeout = setTimeout(
          this.onNotificationClose,
          NOTIFICATION_TIMEOUT
        );
      }
    },
  },
  created() {
    this.getApiConifg();
  },
  beforeDestroy() {
    clearTimeout(this.notification.timeout);
  },
  async mounted() {
    if (this.newsItems.length) {
      this.$modal.show("news-modal");
    }
  },
  methods: {
    async getApiConifg() {
      this.loading = true;
      const res = (await api.getAPIConfig()).data;
      localStorage.removeItem("config");
      localStorage.setItem("config", JSON.stringify(res));
      envServiceAPI.initEnvListener();
      this.loading = false;
    },
    onNewsDismiss() {
      localStorage.setItem(
        LOCAL_STORAGE_NEWS_LAST_VIEWED_AT,
        this.newsItems[0].date_modified
      );
    },
    onNotification({ message, type = NOTIFICATION_TYPE_SUCCESS }) {
      this.notification.message = message;
      this.notification.type = type;
      this.notification.show = true;
    },
    onNotificationClose() {
      this.notification.show = false;
    },
    onWorkflowHistoryEventParamToggle({
      eventParam: { key: eventParamName, isHighlighted },
      eventType,
    }) {
      const {
        settings: { workflowHistoryEventHighlightList },
      } = this;

      this.settings.workflowHistoryEventHighlightList =
        workflowHistoryEventHighlightListAddOrUpdate({
          eventParamName,
          eventType,
          isEnabled: !isHighlighted,
          workflowHistoryEventHighlightList,
        });

      localStorage.setItem(
        LOCAL_STORAGE_SETTINGS.workflowHistoryEventHighlightList,
        JSON.stringify(this.settings.workflowHistoryEventHighlightList)
      );
    },
    async changeTenant(tenant) {
      // 对租户进行切换
      this.loading = true;
      const res = await api.tokenRefreshTenant({ tenantSid: tenant.sid });
      //  localStorage.removeItem('userName');
      //     localStorage.removeItem('language');
      //     localStorage.removeItem('token');
      //     localStorage.removeItem('tenantId');
      // 对获取最新的userInfo
      if (res.status === 200 && res.data) {
        const authData = res.data.authoredUser;
        i18n.locale = authData?.acceptLanguage ?? "zh_CN";
        localStorage.setItem("language", authData?.acceptLanguage ?? "zh_CN");
        this.$i18n.locale = authData?.acceptLanguage ?? "zh_CN";
        localStorage.setItem("userName", authData.userName);
        localStorage.setItem("token", authData.token);
        this.$store.commit("auth/SET_ROUTER_KEY", authData.tenantId);
        this.$store.commit("auth/SET_AUTH_INFO", authData);
        const resTenantList = await api.getTenantList();
        this.loading = false;
        if (resTenantList.status === 200 && resTenantList.data) {
          this.$store.commit("auth/SET_TENANT_LIST", resTenantList.data ?? []);
        } else {
          this.$message.error(i18n.t("dj-获取租户列表失败"));
          return;
        }
      } else {
        this.$message.error(i18n.t("dj-调用iam切换租户失败"));
        this.loading = false;
      }
    },
    logOut() {
      this.$store.commit("auth/CLEAR_USER_STATE");
      localStorage.removeItem("userName");
      this.$router.push({ name: "login" });
      envServiceAPI.destroyEnvListener();
    },
  },
  computed: {
    ...mapGetters("auth", ["userInfo", "tenantList"]),
    userName() {
      const username = this.$store.state ? this.$store.state.auth.userName : "";
      return username;
    },
    isIsV() {
      const userId = this.userInfo ? this.userInfo.userId : "";
      return !(userId ?? "").includes("digiwin.com");
    },
    tenantName() {
      const tenantName = this.userInfo ? this.userInfo?.tenantName ?? "" : "";
      return tenantName;
    },
    tenantId() {
      const tenantId = this.userInfo ? this.userInfo?.tenantId ?? "" : "";
      return tenantId;
    },
  },
};
</script>

<style src="vue-select/dist/vue-select.css"></style>
<style src="vue-virtual-scroller/dist/vue-virtual-scroller.css"></style>
<style src="vue2-datepicker/index.css"></style>
<style lang="less">
@import "ant-design-vue/dist/antd.less";
@import "./styles/theme-flie.less";
@import "./styles/antd-cover.less";
.auth-conatiner {
  display: inline-flex;
  margin-left: auto;
  a {
    margin: 0 8px;
    display: inline-flex !important;
    align-items: center;
  }
}
</style>
<style lang="stylus">
@import 'https://d1a3f4spazzrp4.cloudfront.net/uber-fonts/4.0.0/superfine.css';
@import 'https://d1a3f4spazzrp4.cloudfront.net/uber-icons/3.14.0/uber-icons.css';
@require './styles/definitions';
@require './styles/reset';

global-reset();

@import './styles/base';
@import './styles/modal';
@import './styles/code';

header.top-bar {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  background-color: athena-background;
  padding: 0 16px 0 32px;
  color: #333333;
  height: top-nav-height;

  h2 {
    font-size: 18px;
    margin-right: inline-spacing-large;
    padding: page-margin-y inline-spacing-large page-margin-y 0;
  }

  a {
    display: inline-block;

    h2 {
      color: uber-white-80;
    }

    &.config {
      margin-left: inline-spacing-medium;
      icon('\ea5f');
    }

    &.logo {
      margin-right: layout-spacing-medium;
      position: relative;
    }
  }

  svg {
    display: inline-block;
    height: top-nav-height - 20px;
  }

  spacing = 1.3em;
  nav-label-color = uber-white-40;
  nav-label-font-size = 11px;

  .detail-view span::before {
    font-size: nav-label-font-size;
    color: nav-label-color;
    margin-right: spacing;
  }

  div.workflow-id span::before {
    content: 'WORKFLOW ID';
  }

  div.task-list span::before {
    content: 'TASK LIST';
  }

  .environment-select {
    .vs__dropdown-toggle {
      border-color: transparent;
    }

    .vs__open-indicator {
      height: 10px;
      fill: uber-blue;
    }

    .vs__selected {
      color: white;
      font-weight: bold;
    }
  }
}

body, main {
  height: 100%;
}

main {
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
}

main {
  > section {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;

    > header:last-of-type {
      margin-bottom: layout-spacing-small;
    }

    > header {
      display: flex;
      align-items: flex-start;
      flex: 0 0 auto;

      > * {
        margin: inline-spacing-small;
      }
    }
  }
}

area-loader, section.loading {
  size = 32px;

  &::after {
    content: '';
    display: block;
    position: absolute;
    width: size;
    height: size;
    border-radius: size;
    left: 'calc(50% - %s)' % (size / 2);
    top: 300px;
    border: 3px solid uber-blue;
    border-bottom-color: transparent;
    animation: spin 800ms linear infinite;
  }
}

.main-title {
  font-size: 24px;
  font-weight: 700;
  color: darken(uber-blue, 30%);
}
</style>
